import {
  filtersObjectToQueryString,
  TuningProps,
} from "@feed-factory/feed-factory.models.tuning-props";
import { feedFactoryAxios } from "@feed-factory/feed-factory.helpers";
import { AxiosPromise, CancelTokenSource } from "axios";
import { EntityType } from "@feed-factory/feed-factory.models.ndtrc";
import { ItemFormat } from "@feed-factory/feed-factory.models.item-format";

export const fetchApiItems = (
  entityType: EntityType,
  page: number,
  size: number,
  tuningProps: TuningProps,
  cancelTokenSource?: CancelTokenSource,
  format: ItemFormat = "json",
  showLinks?: boolean
): AxiosPromise => {
  const url = fetchApiItemsUrl(
    entityType,
    page,
    size,
    tuningProps,
    format,
    showLinks
  );
  return feedFactoryAxios.get(url, {
    cancelToken: cancelTokenSource?.token,
  });
};

export const fetchApiItemsUrl = (
  entityType: EntityType,
  page: number,
  size: number,
  tuningProps: TuningProps,
  format: ItemFormat = "json",
  showLinks?: boolean
): string => {
  const apiType = entityType === "EVENEMENT" ? "events" : "locations";
  let queryString = "";
  if (!tuningProps.search && tuningProps.sortField) {
    queryString += `&sortField=${tuningProps.sortField}`;
  }
  if (!tuningProps.search && tuningProps.sortOrder) {
    queryString += `&sortOrder=${tuningProps.sortOrder}`;
  }
  if (tuningProps.search) {
    queryString += `&search=${encodeURIComponent(tuningProps.search)}`;
  }
  if (tuningProps.filters) {
    const filtersString = filtersObjectToQueryString(tuningProps.filters);
    queryString += filtersString ? `&${filtersString}` : "";
  }
  if (showLinks) {
    queryString += `&showLinks=true`;
  }
  return `/${apiType}?page=${page}&size=${size}&format=${format}${queryString}`;
};

export const fetchApiExportSelectedEventsUrl = (
  itemIds: string[],
  format: ItemFormat = "json"
) => {
  const apiType = "events";

  const formData = new FormData();
  formData.append("eventIDs", itemIds.join(";"));
  formData.append("format", format);

  return {
    url: `/${apiType}/export`,
    body: formData,
  };
};
